module.exports = __webpack_public_path__ + "static/media/RRC-JackjonPT-website-imac-mockup-w768.e66edb3b.webp";